var _path;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import React from "react";

const SvgIconPhotography = (_ref) => {
  let {
    svgRef,
    title,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 26,
    height: 26,
    viewBox: "0 0 26 26",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M10.75 7.813h-4.5a.564.564 0 0 0-.563.562v2.25h3.8A4.49 4.49 0 0 1 13 8.937c1.42 0 2.69.658 3.512 1.688h3.8V7.25a.564.564 0 0 0-.562-.563h-6.22a.582.582 0 0 0-.252.06l-1.776.886c-.235.116-.492.18-.756.18h.004zm-5.063 4.5V18.5c0 .31.254.563.563.563h13.5c.31 0 .563-.254.563-.563v-6.188h-2.954a4.5 4.5 0 1 1-8.86 1.125c.001-.386.05-.766.142-1.125H5.687zM4 18.5V8.375a2.252 2.252 0 0 1 2.25-2.25v-.563c0-.309.253-.562.563-.562h2.25c.309 0 .562.253.562.563v.562h1.125l1.775-.886c.313-.155.658-.239 1.006-.239h6.219A2.252 2.252 0 0 1 22 7.25V18.5a2.252 2.252 0 0 1-2.25 2.25H6.25A2.252 2.252 0 0 1 4 18.5zm11.813-5.063a2.812 2.812 0 1 0-5.625 0 2.812 2.812 0 0 0 5.624 0z",
    fill: "#1A202C",
    fillRule: "nonzero"
  })));
};

const ForwardRef = /*#__PURE__*/React.forwardRef((props, ref) => /*#__PURE__*/React.createElement(SvgIconPhotography, _extends({
  svgRef: ref
}, props)));
export default __webpack_public_path__ + "static/media/icon-photography.17b07dd3.svg";
export { ForwardRef as ReactComponent };